import { render } from "./StatistiquesSignalementsPage.vue?vue&type=template&id=3f0a544f&ts=true"
import script from "./StatistiquesSignalementsPage.vue?vue&type=script&lang=ts"
export * from "./StatistiquesSignalementsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__